import React from 'react';
import { Cloud, Code, Database, Zap, Shield, CheckCircle } from 'lucide-react';

const techStack = {
    "Cloud & Infrastructure": {
        icon: Cloud,
        techs: ['AWS', 'Azure', 'GCP', 'Terraform', 'Kubernetes', 'Docker', 'OpenShift'],
        description: "Designing, deploying, and managing scalable, resilient cloud environments."
    },
    "Backend & Software Development": {
        icon: Code,
        techs: ['C# .NET', 'Node.js', 'NestJS', 'Go', 'Python', 'Java', 'Serverless'],
        description: "Building robust, high-performance APIs, microservices, and enterprise applications."
    },
    "Frontend & Web Development": {
        icon: Zap,
        techs: ['React', 'Angular', 'Vue.js', 'TypeScript', 'Tailwind CSS', 'Next.js', 'Redux'],
        description: "Creating responsive, fast, and modern user interfaces."
    },
    "Data Engineering & Storage": {
        icon: Database,
        techs: ['PostgreSQL', 'MongoDB', 'Redis', 'Kafka', 'RabbitMQ', 'Elasticsearch', 'Snowflake','DataLake','Azure Service Bus'],
        description: "Architecting data pipelines, managing databases, and implementing real-time data streams."
    },
    "DevOps & Automation": {
        icon: Shield,
        techs: ['CI/CD (GitLab/GitHub Actions)', 'ArgoCD', 'Prometheus', 'Grafana', 'Ansible', 'Jenkins'],
        description: "Implementing continuous delivery, monitoring, and infrastructure-as-code."
    },
    "Quality Assurance & Security (QA/SecOps)": {
        icon: CheckCircle,
        techs: ['Selenium', 'Cypress', 'JMeter', 'Jest', 'Mocha', 'Snyk', 'OWASP', 'Vault'],
        description: "Ensuring code quality, performance, and integrating security throughout the lifecycle."
    }
};

export default function TechStackSection() {
    return (
        <section id="tech-stack" className="py-20 sm:py-24 bg-gray-900 border-t border-indigo-700/50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h3 className="text-center text-lg font-semibold uppercase text-sky-400 tracking-wider">
                        My Core Technical Expertise
                    </h3>
                    <h2 className="mt-2 text-4xl font-extrabold text-white sm:text-5xl">
                        A Command Over Modern Architectures
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
                    {Object.entries(techStack).map(([category, data]) => (
                        <div
                            key={category}
                            className="bg-gray-800 p-6 rounded-xl shadow-xl border border-gray-700 hover:border-sky-500 transition-all duration-300"
                        >
                            <div className="flex items-center space-x-3 mb-4">
                                <data.icon className="w-7 h-7 text-sky-400" />
                                <h4 className="text-xl font-bold text-white">
                                    {category}
                                </h4>
                            </div>
                            <p className="text-gray-400 text-sm mb-4 min-h-[40px]">{data.description}</p>
                            <div className="flex flex-wrap gap-2 mt-4">
                                {data.techs.map((tech) => (
                                    <span
                                        key={tech}
                                        className="bg-indigo-700/30 text-indigo-300 text-xs font-medium px-3 py-1 rounded-full border border-indigo-600"
                                    >
                                        {tech}
                                    </span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-16 text-center">
                    <p className="text-lg text-gray-400">
                        *Focused on delivering high-quality, maintainable, and cost-effective solutions.
                    </p>
                </div>
            </div>
        </section>
    );
}